module.exports = __webpack_public_path__ + "static/media/logoky.5af69a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoky.png
// module id = 671
// module chunks = 0